import { validate as validatePassword } from '@ynap/password-input'

export default function validate(values, props) {
    const errors = {}
    const { messages } = props
    const passwordError = validatePassword(values.logonPassword, props)

    if (passwordError) {
        errors.logonPassword = passwordError
    }

    if (!values.logonId || !values.logonId.trim()) {
        errors.logonId = messages.errors.required({})
    } else if (!values.logonId.includes('@') || !values.logonId.includes('.')) {
        errors.logonId = messages.errors.invalid({ field: messages.loginForm.logonId() })
    }

    return errors
}
